<script lang="ts" setup>
import { useSEO } from "~/composables/useSeo";
import { useResumeStore } from "~/stores/useResumeStore";

const resumeStore = useResumeStore();
await resumeStore.loadResumeData();

const personalInformation = resumeStore.personalInformation;

// Apply SEO meta tags
useSEO({
  title: `${personalInformation?.name || "Portfolio"} - ${personalInformation?.title || "Software Developer"}`,
  description: personalInformation?.shortPhrase || "Personal portfolio website",
  image: personalInformation?.avatar.main || undefined,
});
</script>
<template>
  <PagesHome />
</template>

<style lang="css"></style>
